import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro'
import React, { Fragment } from 'react'
import { UsuarioEdicaoFirstPage } from '../components/UsuarioFirstPage/usuario-edicao-first-page'
import { UsuarioEdicaoSecondPage } from '../components/UsuarioSecondPage/usuario-edicao-second-page'
import { useUsuarioEdicaoForm } from '../hooks/use-form'
import { useUsuarioEdicaoQueryHandler } from '../hooks/use-query-handler'
import { FormWizard } from '../../hook-form-connectors/form-wizard'
import { parseAsNumberLiteral, useQueryState } from 'nuqs'

enum UsuarioStep {
  DadosBasicos = 0,
  Permissoes = 1
}

const validSteps: readonly UsuarioStep[] = [
  UsuarioStep.DadosBasicos,
  UsuarioStep.Permissoes
]

export const UsuarioEdicaoWizard = () => {
  const { initialValues, schemaArray, submitHandler, onClose, allDataLoaded } =
    useUsuarioEdicaoForm()

  const { tiposMap } = useUsuarioEdicaoQueryHandler()

  const [activeStep, setActiveStep] = useQueryState(
    'activeStep',
    parseAsNumberLiteral(validSteps).withDefault(UsuarioStep.DadosBasicos)
  )

  return (
    <div className={'h-[80vh]'}>
      <div className={'mb-deca'}>
        <p className={'font-bold text-h1 w-full'}>
          {initialValues.id ? initialValues.nome : <Trans>Novo Usuário</Trans>}
        </p>
      </div>
      <FormWizard
        initialValues={initialValues}
        schemaArray={schemaArray}
        submitHandler={submitHandler}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        onClose={onClose}
        canInitialize={allDataLoaded}
      >
        <>
          <Fragment key='dados-basicos'>
            <UsuarioEdicaoFirstPage {...tiposMap} title={t`Dados Básicos`} />
          </Fragment>
          <Fragment key='permissoes'>
            <UsuarioEdicaoSecondPage title={t`Permissões`} />
          </Fragment>
        </>
      </FormWizard>
    </div>
  )
}

export default UsuarioEdicaoWizard
